// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models, types
import {
	CallToActionPosition,
	ICallToAction,
} from '@/interfaces/CallToActionTypes';
import { ICard } from '@/interfaces/Card';
import { IPromotion } from '@/interfaces/Promotion';
import { IShoppingListCategory } from '@/interfaces/ShoppingList';
import { PromotionCarouselItem } from '@/interfaces/PromotionCarouselItem';
import { VuexAction } from '@/@types/index.d';

// store
import {
	GET_MXR_CONFIG_URL,
	GET_CURRENT_CARD,
	GET_SHOPPING_LIST,
	GET_PROMOTIONS,
	GET_VISIBLE_PROMOTIONS,
	GET_TAB_CTA,
	GET_THIRD_TAB_CLICK_REPORT,
	SEND_REPORT,
	GET_FOOTER_BUTTON_CLICKED_REPORT,
} from '@/store/types';
import { IReport } from '@/interfaces/IReport';

@Component({})
export default class Email extends Vue {
	@Prop({ required: true }) label!: string;

	@Prop({ required: true }) subject!: string;

	@Prop({ required: true }) body!: string;

	@Prop({ required: true }) position!: CallToActionPosition;

	@Getter(GET_CURRENT_CARD) getCurrentCard!: ICard;

	@Getter(GET_SHOPPING_LIST) getShoppingList!: IShoppingListCategory[];

	@Getter(GET_VISIBLE_PROMOTIONS) getVisiblePromotions!: IPromotion[];

	@Getter(GET_MXR_CONFIG_URL) getMxrConfigUrl!: string;

	@Getter(GET_PROMOTIONS) getPromotions!: PromotionCarouselItem[];

	@Getter(GET_TAB_CTA) getTabCta!: ICallToAction;

	@Getter(GET_THIRD_TAB_CLICK_REPORT) getThirdTabClickReport!: IReport;

	@Getter(GET_FOOTER_BUTTON_CLICKED_REPORT)
	getFooterButtonClickedReport!: IReport;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	get mailto(): string {
		// TODO: Replace the mapped values with the shopping list and promotions
		const formattedShoppingList = this.getShoppingList
			.map((a) => {
				const formattedProducts = a.items.map((p) => `- ${p.name}`);
				return `${a.name}\n${formattedProducts.join('\n')}`;
			})
			.join('\n\n')
			.concat('\n');
		const headings = this.getPromotions.map(
			(pci: PromotionCarouselItem) => pci.heading
		);
		const formattedPromotions = this.getVisiblePromotions
			.map((p: IPromotion, index: number) => {
				const heading =
					headings.length >= index + 1 ? headings[index] : '';
				return `${heading}\n- ${p.productName}`;
			})
			.join('\n\n');
		const body = encodeURIComponent(
			`${this.getTabCta.emailBody}` +
				`${this.getCurrentCard.title}\n` +
				`${this.getMxrConfigUrl}\n\n` +
				`${formattedShoppingList}\n` +
				`${formattedPromotions}`
		);
		const subject = encodeURIComponent(this.subject);
		return `mailto:?subject=${subject}&body=${body}`;
	}

	handleClick() {
		const report = this.getThirdTabClickReport;
		report.mxrThirdTabButtonClicked!.button = {
			label: this.label,
			type: 'email',
		};
		this.sendReport(report);
		this.sendReport(this.getFooterButtonClickedReport);
	}
}
